import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Column from '~/Common-Objects/Grids/Column/Column'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import TierPermissions from '../../../../Classes/tierPermissions'
import { isVisibleCatalogApp, displayMailchimpAppName } from '~/utils/mailchimpImportBeta'

function AddService({ finish = () => {} }) {
    const account = useSelector((state) => state.accountMaster)
    const canAddDupes = TierPermissions('socialAccounts', account).allowed
    const history = useHistory()

    const [services, setServices] = useState([])
    const [service, setService] = useState(undefined)
    const [category, setCategory] = useState('All')
    const [search, setSearch] = useState('')

    useEffect(() => {
        axios.get('/application').then((response) => {
            const apps = (response.data.Applications || []).filter((app) => isVisibleCatalogApp(app))
            setServices(
                apps.sort((a, b) => {
                    // sort by the "featured" boolean property
                    if (a.featured && !b.featured) return -1
                    if (!a.featured && b.featured) return 1
                    return 0
                })
            )
        })
    }, [])

    var types = ['All']
    services.forEach((service) => {
        if (service.category && types.indexOf(service.category) === -1) types.push(service.category)
    })

    // move the "Other" type to the end
    if (types.includes('Other')) {
        types = types.filter((t) => t !== 'Other')
        types.push('Other')
    }

    let rows = [...services]
    if (category !== 'All') rows = rows.filter((s) => s.category === category)

    if (search?.length > 2) {
        rows = rows.filter((s) => (displayMailchimpAppName(s) || '').toLowerCase().includes(search.toLowerCase()))
    }

    return (
        <div>
            <h4 className='mar-b25'>{i18n.t('company:integrations.add.header')}</h4>
            <div className='row mar-b25'>
                <div className='col-xs-12 col-sm-12 col-md-8 col-lg-10'>
                    {types.map((type, index) => (
                        <ButtonSimple
                            key={'integration_' + index}
                            className='button-simple-fullsize mar-l5'
                            selected={type === category}
                            onClick={() => setCategory(type)}
                        >
                            {type}
                        </ButtonSimple>
                    ))}
                </div>
                <div className='hide-xs hide-sm col-md-4 col-lg-2'>
                    <TextInput
                        placeholder='Search by name...'
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            <Row>
                {rows.map((service) => {
                    let isInstalled = false
                    let allowMultiple = false
                    if (service.AccountApplications.length > 0) {
                        isInstalled = true
                        if (service.AccountApplications[0].UniqueKey) allowMultiple = true
                    }
                    return (
                        <Column xs={12} sm={6} md={6} lg={4} key={service.id}>
                            <App
                                app={service}
                                isInstalled={isInstalled}
                                allowMultiple={allowMultiple}
                                canAddDupes={canAddDupes}
                                onClick={() => finish(service)}
                                upgrade={() => history.push('/cp/company/subscription')}
                            />
                        </Column>
                    )
                })}
            </Row>
        </div>
    )
}

export default AddService

function App({ app, isInstalled, allowMultiple, canAddDupes, onClick = () => {}, upgrade = () => {} }) {
    const beta = !!(app.options && app.options.beta)
    return (
        <Paper
            className={'integration-available-tile' + (beta ? ' integration-available-tile--beta' : '')}
            style={{ position: 'relative', padding: 24, marginBottom: 24, height: 'calc(100% - 24px)' }}
        >
            {beta ? (
                <span className='integration-app-beta integration-app-beta--below-actions'>
                    {i18n.t('company:integrations.main.beta')}
                </span>
            ) : null}
            <div
                className='avatar'
                style={{
                    backgroundImage: 'url(' + app.appLogoUri + ')',
                    width: 48,
                    height: 48,
                    backgroundSize: '48px 48px',
                    marginBottom: 16
                }}
            />
            <div className='text-heavy' style={{ marginBottom: 4 }}>
                {displayMailchimpAppName(app)}
            </div>
            <div className='text-grey'>{app.appDescription}</div>

            <div style={{ position: 'absolute', top: 24, right: 24 }}>
                {!isInstalled && (
                    <Button
                        text={i18n.t('company:integrations.add.viewInstall')}
                        className='button-primary button-sml'
                        onClick={onClick}
                    />
                )}
                {isInstalled && !allowMultiple && (
                    <Button text={i18n.t('company:integrations.add.installed')} className='button-sml' />
                )}
                {allowMultiple && canAddDupes && (
                    <Button
                        text={'Add Another Account'}
                        className='button-primary button-sml'
                        onClick={onClick}
                    />
                )}
                {allowMultiple && !canAddDupes && (
                    <Button text={'Upgrade to Add'} className='button-sml' onClick={upgrade} />
                )}
            </div>
        </Paper>
    )
}
